import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexDirection: 'row',
  width: '100%',
  borderBottomWidth: '0.5px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.grey['300'],
  mb: 1.5,
  pb: 1.5,
};

export const linkOut: SxStyle = {
  minWidth: 4.5,
  color: (p) => p.palette.grey['700'],
};

export const skeleton: SxStyle = {
  width: '100%',
  height: (p) => p.spacing(7),
  mb: 2,
};
